export default {
  auth: true,
  admin: true,
  slug: 'admin',
}
